import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useScreen } from '../../../hooks'
import ButtonComponent from '../../Button'

import * as styles from './RequestCreateButton.module.css'

import PlusIcon from '../../../icons/plus.svg'

function RequestCreateButton({
  Button = ButtonComponent.Contained,
  beforeIconProps: { Icon = PlusIcon, ...beforeIconProps } = EMPTY_OBJECT,
  className,
  textKey = 'RequestTable.AddNewBtnKey',
  ...buttonProps
}) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <Button
      {...buttonProps}
      beforeIconProps={{ ...beforeIconProps, Icon }}
      className={classNames(className, {
        [styles.mobileSize]: isMobileScreenSize,
      })}
      text={isMobileScreenSize ? null : t(textKey)}
    />
  )
}

export default RequestCreateButton
